import { registerGlobalEventListener } from "@modules/util/events"

const topAdvertsContainer = () => document.querySelector(".top-anzeigen")

export function showTopAdverts() {
    topAdvertsContainer()?.classList.remove("hidden")
}

export function hideTopAdverts() {
    topAdvertsContainer()?.classList.add("hidden")
}

registerGlobalEventListener("azm.filter-api.after-fetch", (event) => {
    const topAdverts = document.getElementById("top-anzeigen")
    if (topAdverts) {
        topAdverts.innerHTML = event.detail.topAdverts
    }
})
